import { getISOStartOrEndOfDay } from '../../helpers/datetime'
import { isInValidValue } from '../../helpers/value'

export const add0 = (date) => {
  if (date < 10) {
    return '0' + date
  }
  return date
}

export const convertResultDate = (
  resultDate,
  timezone,
  isStartOfDay = true,
) => {
  const resultDateConvertes =
    resultDate.getFullYear() +
    '/' +
    add0(resultDate.getMonth() + 1) +
    '/' +
    add0(resultDate.getDate())

  return getISOStartOrEndOfDay(resultDateConvertes, timezone, isStartOfDay)
}

export const checkMinYear = (year, minYear) => {
  if (!minYear) {
    return true
  }

  return year >= minYear
}

export const checkMaxYear = (year, maxYear) => {
  if (!maxYear) {
    return true
  }

  return year <= maxYear
}

export const checkMinMonth = (year, minYear, month, minMonth) => {
  if (!minYear || isInValidValue(minMonth)) {
    return true
  }

  if (year > minYear) {
    return true
  }

  return month >= minMonth
}

export const checkMaxMonth = (year, maxYear, month, maxMonth) => {
  if (!maxYear || isInValidValue(maxMonth)) {
    return true
  }

  if (year < maxYear) {
    return true
  }

  return month <= maxMonth
}

export const getDateByLocale = (str) => {
  let [day, month, year] = str.split('/').map(Number)
  return new Date(year, month - 1, day)
}
